import * as React from 'react';

import PageComponent from '/Users/cainiao/Documents/project/fpx-giws-web/src/pages/FpxDemo';

const PageComponentName = PageComponent;

export default PageComponentName;
